module.exports = __webpack_public_path__ + "img/sodam_img01.db7d0355.jpg";